










































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import DataStores from "@/views/Stats/DataStores/DataStoresList.vue"
import Tags from "@/views/Stats/Tags/Tags.vue"
import Scripts from "@/views/Stats/Scripts/ScriptsList.vue"
import StatsExpressions from "@/views/Stats/StatsExpressions/StatsExpressions.vue"

@Component({
  components: { DataStores, Tags, Scripts, StatsExpressions }
})
export default class Data extends Super {
  showStats = false

  mounted(){
    this.http(`/accounts/me/has-permission-for/stats/view?eventID=${this.eventIDGetter}`)
    .then(res => {
      this.showStats = res.data
    }).catch(this.displayError)
  }
}
